import React from "react";
import { Redirect, useLocation, useParams } from "react-router-dom";
import { bookkeepingPath, BookkeepingSection } from "./navigation";

const LegacyRedirect = ({ section }: { section: BookkeepingSection }) => {
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const location = useLocation();
  return (
    <Redirect
      to={{ ...location, pathname: bookkeepingPath(restaurantId, section) }}
    />
  );
};

export default LegacyRedirect;
